export const VENDOR_MOBILE_NO = "VQ_Vendor_mobile_no";
export const VENDOR_MOBILE_NO_SUCCESSFUL = "VQ_Vendor_mobile_no_successfull";
export const GENERATE_OTP = "VQ_generate_OTP";
export const GENERATE_OTP_SUCCESSFUL = "VQ_generate_OTP_successfull";
export const CHECK_OTP = "VQ_check_OTP";
export const CHECK_OTP_SUCCESSFUL = "VQ_check_OTP_successfull";

// Vendor Quotation Report
export const Q_DOC_REPORT = "vend_reports_q_Doc";
export const Q_DOC_REPORT_SUCCESS = "vend_reports_q_Doc_Successful";
export const Q_DOC_PDF = "vend_report_q_doc_pdf";

export const API_ERROR = "api_failed";
